import script from "./data-mahasiswa.vue?vue&type=script&setup=true&lang=ts"
export * from "./data-mahasiswa.vue?vue&type=script&setup=true&lang=ts"

import "./data-mahasiswa.vue?vue&type=style&index=0&id=2e03d6c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e03d6c8"]])

export default __exports__